import React, { Component } from 'react';
import Modal from '../../../components/modals';
import ProjectsGraphQl from '../../../../controllers/projectsGraphQl';
import { gql } from '@apollo/client';
import _ from 'lodash';
import { toast } from 'react-toastify';

import InputHeader from '../../global/inputwithHeader';
import { ReactComponent as Cancel } from '../../../../assets/svg/cancel-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/svg/trash3.svg';
import LoadingBar from '../../../components/global/loadingBar';

import moment from 'moment';
import { withRouter } from '../../../../services/withRoute';
import TenantUsersController from '../../../../controllers/tenantUsers';
import jwt_decode from 'jwt-decode';
import Select from 'react-select';
const assignAsset = gql`
	mutation AddAssetToEmp($identifier: String!, $employee: EmployeeObjectInput) {
		addAssetToEmp(identifier: $identifier, employee: $employee) {
			branch {
				_id
				branchId
			}
			createdAt
			createdBy
			description
			employees {
				_id
				name
			}
			id
			notes {
				_id
				files
			}
			qrCode
			serialNumber
			status
			type
			updatedAt
			updatedBy
			workspaceId
		}
	}
`;
class AssignAsset extends ProjectsGraphQl {
	constructor(props) {
		super(props);
		this.state = {
			qrCode: '',
			isAPISubmitting: false,
			selectedAssetType: {},
			serialNumber: '',
			assetType: '',

			assetTypeOptions: [
				{ label: 'Keyboard', value: 'keyboard' },
				{ label: 'Mouse', value: 'mouse' },
				{ label: 'Memory Card Reader', value: 'memoryCardReader' },
				{ label: 'Hub', value: 'hub' },
				{ label: 'iMac', value: 'iMac' },
				{ label: 'MacBook', value: 'macbook' },
				{ label: 'Mobile Phone', value: 'mobilePhone' },
				{ label: 'Sim', value: 'sim' },
				{ label: 'Monitor', value: 'monitor' },
				{ label: 'CPU', value: 'CPU' },
				{ label: 'Headphone', value: 'headphone' },
				{ label: 'Adapter', value: 'adapter' },
				{ label: 'Chair', value: 'chair' },
				{ label: 'Laptop', value: 'laptop' },
			],
		};
	}
	componentDidMount = async () => {};
	handleCloseModal = () => {
		this.props.close();
	};
	assignAssetAPICall = async () => {
		if (this.state.isAPISubmitting === false) {
			this.setState(
				{
					isAPISubmitting: true,
				},
				() => {
					let json = {
						employee: this.props.employee,
					};
					if (this.state.qrCode.length === 8) {
						json = {
							...json,
							identifier: this.state.qrCode,
						};
					} else {
						json = {
							...json,
							identifier: this.state.serialNumber,
						};
					}

					this.assignAsset(assignAsset, json).then(() => {
						window.location.reload();
					});
				},
			);
		}
	};
	render() {
		return (
			<Modal
				handleClose={() => this.handleCloseModal()}
				show={this.props.show}
				modalType={'center'}
			>
				<div
					className="mc-record-center-modal2"
					style={{
						height: '75vh',
					}}
				>
					<div className="mc-record-header">
						<span className="header-title">Assign Asset</span>
						<span className="header-more-icn" onClick={() => this.handleCloseModal()}>
							<Cancel />
						</span>
					</div>

					<>
						<div
							style={{
								height: '100%',
								width: '100%',
							}}
						>
							<div
								style={{
									height: '100%',
									width: '100%',
									flexDirection: 'column',
									justifyContent: 'center',
									alignItems: 'center',
								}}
							>
								<div
									style={{
										width: '100%',
										padding: '30px',
									}}
								>
									<label
										htmlFor=""
										style={{
											color: '#B0B0B0',
										}}
									>
										Qr Code
									</label>
									<br />
									<input
										style={{ marginBottom: '16px' }}
										className="qrcode"
										value={this.state.qrCode}
										placeholder="Enter QR Code"
										autoFocus={true}
										onChange={(e) =>
											this.setState({
												qrCode: e.target.value,
											})
										}
									/>
									<p
										style={{
											color: '#B0B0B0',
											marginTop: '20px',
											marginBottom: '20px',
										}}
									>
										Or
									</p>
									<label
										htmlFor=""
										style={{
											color: '#B0B0B0',
											marginBottom: '8px',
										}}
									>
										Asset Type
									</label>
									<br />

									<Select
										value={this.state.selectedAssetType}
										className="cost-select-container"
										classNamePrefix="cost-select"
										options={this.state.assetTypeOptions}
										onChange={(e) => {
											this.setState({
												selectedAssetType: e,
												assetType: e.value,
											});
										}}
									/>
									<div
										style={{
											height: '20px',
										}}
									></div>
									<label
										htmlFor=""
										style={{
											color: '#B0B0B0',
											marginTop: '20px',
										}}
									>
										Serial Number
									</label>

									<input
										style={{ marginTop: '8px', marginBottom: '16px' }}
										className="qrcode"
										value={this.state.serialNumber}
										placeholder="Enter Serial Number"
										autoFocus={true}
										onChange={(e) =>
											this.setState({
												serialNumber: e.target.value,
											})
										}
									/>
									<div
										style={{
											display: 'flex',
											alignItems: 'center',
											justifyContent: 'center',
										}}
									>
										<button
											className="create-shoot-btn"
											onClick={() => this.assignAssetAPICall()}
										>
											Confirm
										</button>
									</div>
								</div>
							</div>
						</div>
					</>
				</div>
			</Modal>
		);
	}
}
export default withRouter(AssignAsset);
